import type { Theme } from '@material-ui/core';
import { CircularProgress, createStyles, Grid, makeStyles, Typography } from '@material-ui/core';
import { Dialog } from '@nutrien/cxp-components';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      display: 'flex',
      justifyContent: 'space-evenly',
      flexDirection: 'column',
    },
    progress: {
      display: 'flex',
      height: '100%',
      marginTop: theme.spacing(2),
    },
    message: {
      marginTop: '20px',
      textAlign: 'center',
    },
    spinnerDiv: {
      maxHeight: '50%',
    },
    spinner: {
      color: `${theme.palette.primary.main}`,
    },
  }),
);

const DataLoadingDialog = () => {
  const classes = useStyles();

  return (
    <Dialog
      open
      titleText="Data loading"
      backButton={false}
      disableEnforceFocus
      maxWidth="xs"
      maxHeight="200px"
      BackdropProps={{
        onClick: event => {
          event.preventDefault();
        },
        onTouchStart: event => {
          event.preventDefault();
        },
        style: { touchAction: 'none' },
      }}
    >
      <div className={classes.dialog}>
        <div className={classes.spinnerDiv}>
          <Grid
            container
            item
            xs={12}
            justifyContent="center"
            alignContent="flex-start"
            className={classes.progress}
          >
            <CircularProgress className={classes.spinner} />
          </Grid>
          <Typography variant="body1" className={classes.message}>
            Please wait while we load the data.
          </Typography>
        </div>
      </div>
    </Dialog>
  );
};

export default DataLoadingDialog;
